import FingerprintJS from "@fingerprintjs/fingerprintjs";

// currently only used for MFA "Remember this device"
export const getDeviceFingerprint = async (): Promise<string> => {
  const fp = await FingerprintJS.load();
  const result = await fp.get();
  return result.visitorId;
};
